import React, { useState } from 'react';
import * as PropTypes from 'prop-types';
import CustomScroll from 'react-scrollbars-custom';

/**
 * Custom scrollbar that uses native scrolling but with a minimal UI
 */
const Scrollbar = ({ children, className, useAdditionalPadding }) => {
  const [isScrollingClass, setIsScrollingClass] = useState('');
  const toggleScrolling = (isScrolling) =>
    setIsScrollingClass(isScrolling ? 'isScrolling' : '');

  return (
    <CustomScroll
      className={className}
      trackYProps={{ className: isScrollingClass }}
      onScroll={() => toggleScrolling(true)}
      onScrollStop={() => toggleScrolling(false)}
      disableTracksWidthCompensation={!useAdditionalPadding}
    >
      {children}
    </CustomScroll>
  );
};

Scrollbar.propTypes = {
  className: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
  useAdditionalPadding: PropTypes.bool,
};
export default Scrollbar;
